import React, { useState } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import Cart from './Cart';
import Breakpoint from 'react-socks';
import { FaBars, FaUser } from 'react-icons/fa';

function NavMenu(props) {
  const [menuIsOpen, setIsMenuOpen] = useState(false);
  const inlineNavLinkClass = "block lg:inline-block lg:mt-0  text-cruise_darkblue px-3 py-1 rounded hover:no-underline hover:bg-orange-500 hover:text-white";
  const mobileNavClass = "";

  function toggleMenu() {
    setIsMenuOpen(!menuIsOpen);
  }
  function renderMenu(linkClass) {
    return <React.Fragment>
      <NavLink tag={Link} className={linkClass} to="/">Home</NavLink>
      <NavLink tag={Link} className={linkClass} to="/search">Offers</NavLink>
      <NavLink tag={Link} className={linkClass} to="/discover">Discover</NavLink>
      <NavLink tag={Link} className={linkClass} to="/contact">Contact</NavLink>
      <NavLink tag={Link} className={linkClass} to="/about">FAQ</NavLink>
    </React.Fragment>
  }

  return (
    <nav className="bg-lightblue-gradient py-2 sm:px-8">
      <Breakpoint xs only >
        <div className="flex justify-around items-center font-bold">
          <FaBars className="cursor-pointer" onClick={toggleMenu} />
          <span>SIMA</span>
          <FaUser />
        </div>
        {menuIsOpen ? <div className="absolute flex flex-col">{renderMenu(mobileNavClass)}</div> : null}
      </Breakpoint>
      <Breakpoint sm up>
        <div className="flex justify-around items-center">
          <div className="flex text-cruise_darkblue">
            <span className="font-semibold text-xl tracking-tight">SIMA</span>
          </div>
          <span className="whitespace-no-wrap">Call +45 87 35 93 48</span>
          <div className="flex justify-center w-auto">
            <div className="text-sm flex-grow inline-flex justify-center">
              {renderMenu(inlineNavLinkClass)}
            </div>
          </div>
          <div className="flex w-20 justify-between items-center whitespace-no-wrap"><FaUser /> Sign in</div>
        </div>
      </Breakpoint>
    </nav>
  );
}

export default NavMenu;
